<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Card stats -->
      <b-row v-if="listGroups">
        <template v-for="(item, key) in listGroups">
          <b-col @click="getGroupData(item.id)" :key="key">
            <stats-card
              :title="item.nombre"
              type="gradient-red"
              :nGrupos="item.grupos_count"
              :catecumenos="item.num_ninos"
              class="mb-4"
              :backGround="item.backGround"
              :responsable="item.responsables"
            >
            </stats-card>
          </b-col>
        </template>
      </b-row>
    </base-header>
    <b-container> </b-container>
  </div>
</template>
<script>
// Charts
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";

// Components
import BaseProgress from "@/components/BaseProgress";
import StatsCard from "@/components/Cards/StatsCard";

//Spinner
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  components: {
    LineChart,
    BarChart,
    BaseProgress,
    StatsCard,
  },
  data() {
    return {
    };
  },
  computed:{
    listGroups(){
      if(this.$store.getters.getCursosGruposNum != undefined){
        loader.close();
        return this.$store.getters.getCursosGruposNum;
      }else{
        loader.open();
        this.$store.dispatch("cargarCountCursosGrupos");
        return null;
      }
    },
  },
  methods: {
    getGroupData(id) {
      this.$router.push({
        name: "groups",
        query: { id: id },
      });
    },
  },
};
</script>
<style>
.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
